import { Link } from "react-router-dom"
import supabase from "../config/supabaseClient"
const FanyCard = ({fany, onDelete}) =>{
    const handleDelete = async () => {
        const { data, error } = await supabase
          .from('fanytable')
          .delete()
          .eq('id', fany.id)
        
        if (error) {
          console.log(error)
        }
        if (data) {
          console.log(data)
          onDelete(fany.id)
        }
      }
    return(
        <div className="fany-card">
            <h3>{fany.title}</h3>
            <p>{fany.method}</p>
            <div className="rating">{fany.rating}</div>
            <div className="buttons">
                <Link to={'/'+fany.id}>
                    <i className="material-icons">edit</i>
                </Link>
                <i className="material-icons" onClick={handleDelete}>delete</i>
            </div>
        </div>
    )
}



export default FanyCard